import React from 'react';
import PropTypes from 'prop-types';
import NavigationContext from './Context';
import {getNavigation} from '../../services/havr';
import {transformNavigation} from './NavigationDataTransforms';

class HavrProvider extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            navigation: null,
        };
    }

    componentDidMount() {
        if (this.state.navigationPromise) {
            this.state.navigationPromise.then((navigation) => {
                this.setState({
                    ...this.state,
                    navigation,
                    loaded: true,
                });
            });
        }
    }

    componentDidUpdate() {
        if (this.state.navigationPromise) {
            this.state.navigationPromise.then((navigation) => {
                this.setState({
                    ...this.state,
                    navigation,
                    loaded: true,
                });
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let nextState = prevState;
        if (!nextState.navigationPromise || nextProps.tourId !== prevState.tourId) {
            nextState.tourId = nextProps.tourId;
            nextState.navigationPromise = getNavigation(nextState.tourId).then(transformNavigation);
        }
        return nextState;
    }

    render() {
        return (
            <NavigationContext.Provider value={this.state.navigation}>
                {this.props.children}
            </NavigationContext.Provider>
        );
    }
}

HavrProvider.propTypes = {
    tourId: PropTypes.string,
    tourVersion: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default HavrProvider;
